import styled from "styled-components"

export const BlockedContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  text-align: center;
  color: ${(p) => p.theme.colors.greyDarker};
`

export const BlockedIcon = styled.div`
  margin-bottom: 1.6rem;

  svg {
    width: 4rem;
    height: 4rem;
    fill: ${(p) => p.theme.colors.grey};
  }
`

export const BlockedTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 0.4rem;
`

export const BlockedDescription = styled.div`
  font-size: 1.3rem;
  color: ${(p) => p.theme.colors.greyDark};
`
